import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

interface NavItem {
  icon: string;
  activeIcon: string;
  label: string;
  path: string;
}

export function BottomNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const navItems: NavItem[] = [
    { icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: t('bottomNav.home'), path: '/' },
    { icon: 'ri-compass-3-line', activeIcon: 'ri-compass-3-fill', label: '탐색', path: '/explore' },
    { icon: 'ri-chat-3-line', activeIcon: 'ri-chat-3-fill', label: '피드', path: '/boards' },
    { icon: 'ri-user-3-line', activeIcon: 'ri-user-3-fill', label: t('bottomNav.profile'), path: '/profile' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white z-50" style={{ boxShadow: '0 -1px 0 rgba(0,0,0,0.08)' }}>
      <div className="flex justify-around items-center h-[52px] max-w-[480px] mx-auto">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center flex-1 h-full cursor-pointer"
            >
              <i className={`${active ? item.activeIcon : item.icon} text-[22px] transition-colors duration-150 ${
                active ? 'text-[#222222]' : 'text-[#717171]'
              }`} />
              <span className={`text-[10px] mt-0.5 transition-colors duration-150 ${
                active ? 'text-[#222222] font-semibold' : 'text-[#717171]'
              }`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
      {/* iOS 하단 세이프 에어리어 */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}
